import { SLOPE_DEGREE, SLOPE_RISE } from "../constants/CALCULATOR_VALUES";
import { CT_ENCLOSURE_CLASSIFICATION, CT_EXTERNAL_FIRE, CT_HAIL, CT_INTERNAL_FIRE, CT_PRESSURE_ZONE, CT_SURFACE_ROUGHNESS } from "../constants/CODETABLES";
var getDateWithFormat = function (dateString) { var monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]; var dateObj = new Date(dateString); var year = dateObj.getFullYear(); var month = monthNames[dateObj.getMonth()]; var day = dateObj.getDate(); return "".concat(month, " ").concat(day, ", ").concat(year); };
var getSlopeDegree = function (roofAreaSlope) { for (var i = 0; i < SLOPE_RISE.length; i++) {
    if (roofAreaSlope == SLOPE_RISE[i].value) {
        return Number(SLOPE_DEGREE[i].value);
    }
} return 0; };
var getValueCode = function (propType, propValue) { var targetItem; switch (propType) {
    case 'IF':
        targetItem = CT_INTERNAL_FIRE.find(function (item) { return item.value === propValue; });
        break;
    case 'EF':
        targetItem = CT_EXTERNAL_FIRE.find(function (item) { return item.value === propValue; });
        break;
    case 'HL':
        targetItem = CT_HAIL.find(function (item) { return item.value === propValue; });
        break;
    case 'EC':
        targetItem = CT_ENCLOSURE_CLASSIFICATION.find(function (item) { return item.value === propValue; });
        break;
    case 'SR':
        targetItem = CT_SURFACE_ROUGHNESS.find(function (item) { return item.value === propValue; });
        break;
    default: break;
} return targetItem ? targetItem.name : ''; };
var getZoneTypeById = function (zoneTypeId) { var targetZone = CT_PRESSURE_ZONE.find(function (item) { return item.value === zoneTypeId; }); return targetZone ? targetZone.name : ''; };
export { getDateWithFormat, getSlopeDegree, getValueCode, getZoneTypeById };
